import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";
import "react-toastify/dist/ReactToastify.css";
import { CartProvider } from "./context/CartContext";
import { FavoritesProvider } from "./context/FavoritesContext";
import { register } from "./serviceWorkerRegistration";
import { installNativeGeolocationShim } from "./utils/nativeGeolocationShim";

installNativeGeolocationShim();

const root = ReactDOM.createRoot(document.getElementById("root"));
register();
root.render(
  <CartProvider>
    <FavoritesProvider>
      <App />
    </FavoritesProvider>
  </CartProvider>
);
